import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { selectors as priceMatrixSelectors, actions as priceMatrixActions } from 'ducks/inventoryEnquiry/pricing/priceMatrix';
import { selectors as productSelectors } from 'ducks/SearchLookUp/productLookup';
import { fetch } from 'api/inventoryEnquiry/pricing/priceMatrix';
import { actions as filterActions, selectors as filterSelectors } from 'ducks/common/filters';
const params = new URLSearchParams(location.search);

export const mapStateToProps = state => ({
  gridName: 'PriceMatrix',
  columnDefs: priceMatrixSelectors.lineColumns(state),
  detailColumns: priceMatrixSelectors.detailColumns(state),
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
  gridOptions: priceMatrixSelectors.gridOptions(state),
  isLoading: priceMatrixSelectors.isLoading(state),
  filterRow: priceMatrixSelectors.filterRow(state),
  selectedFilters: priceMatrixSelectors.selectedFilters(state),
  reqParams: (productSelectors.selected(state) || params.get('ProductId')) && {
    ProductId: (productSelectors.selected(state) && productSelectors.selected(state).ProductId) || params.get('ProductId')
  },
  appliedFilters: priceMatrixSelectors.filterRow(state) && filterSelectors.getFilters(state, priceMatrixSelectors.filterRow(state).formName),
  apiMethod: fetch
});

export const actions = {
  changeSelectedTab: uiActions.changeSelectedTab,
  setSelectedOrderLine: priceMatrixActions.setSelected,
  changeOperationMode: operationActions.changeOperationMode,
  applyFilters: filterActions.applyFilters
}